<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronLeftIcon from "svelte-material-icons/ChevronLeft.svelte"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import { breadcrumbs } from "../../store"
    import { debounce } from "../../utils"
    import { langField } from "../../i18n"

    export let triggerMenu: Function
    export let nodes: CategoryNode[]
    export let level: number = 1

    let menu_open = "none"
    const triggerSubMenu = (which: string, ref: string) => {
        if (
            (ref == "over" || ref == "out") &&
            typeof window !== "undefined" &&
            window.innerWidth <= 768
        ) {
            return
        }
        console.log(which, ref)
        menu_open = which ?? "none"

        if (!which && ref != "back" && ref != "out") {
            // close also upper
            triggerMenu(undefined, "click sub")
        }
    }

    const debounceTriggerSubMenu = debounce(triggerSubMenu, 300)
    const debounceTriggerMenu = debounce(triggerMenu, 300)
</script>

<ul on:mouseleave="{() => debounceTriggerMenu(undefined, 'out')}">
    <li class="back" on:click="{() => triggerMenu(undefined, 'back')}">
        <ChevronLeftIcon size="22px" />
        {$_("header.back")}
    </li>
    {#each nodes as n (n.id)}
        <li
            class:active="{menu_open == 'menu_' + n.id ||
                ($breadcrumbs?.length > level &&
                    $breadcrumbs[level].id == n?.id)}"
            class:has_children="{n.childObjects?.length > 0}"
            on:mouseenter="{() =>
                debounceTriggerSubMenu('menu_' + n.id, 'over')}"
        >
            <a
                href="{langField(n.path, '')}"
                on:click="{() => triggerMenu(undefined, 'click')}"
                ><span class="image"
                    ><img
                        src="{n.image?.src
                            ? n.image.src + '?filter=xs'
                            : '/media/kein-bild.jpg'}"
                        alt="nav1"
                    /></span
                ><span class="text">{langField(n.name, "")}</span></a
            >
            {#if n.childObjects?.length > 0}
                <span
                    class="navtrigger"
                    on:click="{() =>
                        triggerSubMenu(
                            menu_open == 'menu_' + n.id
                                ? 'none'
                                : 'menu_' + n.id,
                            'trigger'
                        )}"
                >
                    <ChevronDownIcon size="22px" />
                </span>
                {#if menu_open == "menu_" + n.id}
                    <svelte:self
                        triggerMenu="{triggerSubMenu}"
                        nodes="{n.childObjects}"
                        level="{level + 1}"
                    />
                {/if}
            {/if}
        </li>
    {/each}
</ul>
